// Testing constants
export const eggAssetTokenId = "G1r2bKT6wwoScJ9k213SGoaQVjwZs16TLRhuYowNy77f"
export const adoptionContract = "3NAojjoUnKBrRXG9mCbkSDaUEcVaMXkVMoS"
export const auctionAddresss = "3MpZUVUydnP6sJRLkmfFVzbPyZxCJaMF26C"
export const exchangeToeknAddress = "3Mvze35RhgMCjGrqEnhQLjgtVUJVh8c2svx"

//Network
export const nodeUrl = 'https://nodes-testnet.wavesnodes.com/';

/*
// Old Testing constants
export const eggAssetTokenId = "2cf6jyVG19oHU79R8iHfqFEesjstr3e7nSYEUhb2WagB"
export const adoptionContract = "3N4uWa2T9W2p4WgDwLPo3kWRp8eXRatp4vv"
export const auctionAddresss = "3MtVYGt1cJJB8g21cvSzJScK3hxUi9JHdcN"
export const exchangeToeknAddress = "3MxSZ4FPq75Q3cQcf9VJkKFDJkeFpm5Ynm3"

//Network
export const nodeUrl = 'https://nodes-testnet.wavesnodes.com/';
*/